import { Component, Input } from '@angular/core';
import { ClaimSubmissionReviewAttributes } from '../../claim-submission.model';

@Component({
  selector: 'lib-total-provider-charges-review',
  templateUrl: './total-provider-charges-review.component.html',
  styleUrls: ['./total-provider-charges-review.component.scss'],
})
export class TotalProviderChargesReviewComponent {
  @Input() totalProviderChargesConfig: ClaimSubmissionReviewAttributes;
  @Input() totalClaimLineCharges: number;
}
